import { render, staticRenderFns } from "./DataTableSubUser.vue?vue&type=template&id=28c72d80"
import script from "./DataTableSubUser.vue?vue&type=script&lang=js"
export * from "./DataTableSubUser.vue?vue&type=script&lang=js"
import style0 from "./DataTableSubUser.vue?vue&type=style&index=0&id=28c72d80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports